import {
  Tree,
  Input,
  Row,
  Col,
  Checkbox,
  CheckboxProps,
  message,
  Button,
  Space,
  notification,
  TreeSelect,
} from "antd";
import { useEffect, useState } from "react";
import type { DataNode } from "antd/es/tree";
import {
  GetAllCategories,
  GetCategorySelectListVm,
} from "../../services/CategoryService";
import CustomButton from "../share/customButton";
import {
  CreateInvitation,
  UpdateInvitation,
} from "../../services/InvitationService";
import { NotificationPlacement } from "antd/es/notification/interface";
import TextArea from "antd/es/input/TextArea";
import { GetAllClasses } from "../../services/ClassesService";
import { Autocomplete, TextField } from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";
import { GetMyNotices } from "../../services/NoticeService";
import { ColorPalette } from "../share/color/colorPalette";
interface ChildComponentProps {
  onComponentChange: () => void;
  invitationEditData: any;
}
const NewCompanyInvitationV2: React.FC<ChildComponentProps> = ({
  onComponentChange,
  invitationEditData,
}) => {
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
  const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
  const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true);
  const [getNoticeAutocomplete, setNoticeAutocomplete] = useState([]);
  const [getSelectedNoticeOption, setSelectedNoticeOption] = useState(null);
  const [getSelectedClassId, setSelectedClassId] = useState(null);
  const [GetAllCategoriesData, SetAllCategoriesData] = useState<any>(null);
  const [getAllTagsData, setAllTagsData] = useState<any>(null);
  const [getPublishedNoticeData, setPublishedNoticeData] = useState<any>(null);

  const onExpand = (expandedKeysValue: React.Key[]) => {
    console.log("onExpand", expandedKeysValue);
    // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.

    console.log(expandedKeysValue);
    setExpandedKeys(expandedKeysValue);
    setAutoExpandParent(false);
  };
  //CompanyInvitation State Start
  const [getData, setData] = useState<any>({
    InvitationType: 1,
  });
  const [getDataEdit, setDataEdit] = useState<any>({
    TypeOfUpdate: 1,
    description: invitationEditData?.description,
    classId: invitationEditData?.classId,
    invitationId: invitationEditData?.id,
    phoneNumber: invitationEditData?.phoneNumber,
    email: invitationEditData?.email,
  });

  const SetUnSavedDataInfo = (e: any) => {
    setData({
      ...getData,
      [e.target.id]: e.target.value,
    });
  };

  const SetUnSavedDataInfoManual = (id: any, value: any) => {
    console.log("eee", { id, value });

    setData({
      ...getData,
      [id]: value,
    });
  };
  const SetUnSavedDataInfoForEdit = (e: any) => {
    console.log(e);

    setDataEdit({
      ...getDataEdit,
      [e.target.id]: e.target.value,
    });

    //console.log("GetSelectedNoticeDetails", GetSelectedNoticeDetails);
  };
  const [showPhoneNumber, setShowPhoneNumber] = useState(true);
  const onChange: CheckboxProps["onChange"] = (e) => {
    if (e.target.checked === true) {
      setData({
        ...getData,
        ["phoneNumber"]: "0",
      });

      setDataEdit({
        ...getDataEdit,
        ["phoneNumber"]: "0",
      });
      setShowPhoneNumber(false);
    } else {
      setShowPhoneNumber(true);
      setData({
        ...getData,
        ["phoneNumber"]: "",
      });
    }
  };
  //CompanyInvitation End

  const onSelect = (selectedKeysValue: React.Key[], info: any) => {
    console.log("onSelect", info);
    //setSelectedKeys(selectedKeysValue);
  };
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const paste = e.clipboardData.getData("text");
    if (!/^\d+$/.test(paste)) {
      e.preventDefault();
    }
  };
  useEffect(() => {
    GetCategorySelectListVm().then((p) => SetAllCategoriesData(p.data.data));
    GetMyNotices(0).then((p) => {
      // console.log(
      //   "ffsa",
      //   p.data.filter((f: any) => f.noticeState === 5)
      // );
      const transformedData2 = p.data
        .filter((f: any) => f.noticeState === 5)
        .map((item: any) => ({
          value: item.id,
          title: item.title,
        }));
      setPublishedNoticeData(transformedData2);
      //console.log("t2", transformedData2);
    });

    GetAllClasses().then((p) => {
      const transformedData = p.data.data.map((item: any) => ({
        value: item.id,
        title: item.name,
        children: [],
      }));
      console.log("ddddd", invitationEditData?.classId);
      setAllTagsData(transformedData);
      //setGetCategoryAutocomplete(transformedData);
      if (
        invitationEditData?.classId !== undefined &&
        invitationEditData?.classId !== null
      ) {
        // console.log(
        //   "ddd",
        //   transformedData.filter(
        //     (p: any) => p.value === invitationEditData?.classId
        //   )
        // );

        setAllTagsData(
          transformedData.filter(
            (p: any) => p.value === invitationEditData?.classId
          )[0]
        );
      }
    });
    console.log("invitationEditData", invitationEditData);
  }, []);
  useEffect(() => {
    console.log("dddd", getAllTagsData);
  }, [getAllTagsData]);

  useEffect(() => {
    if (getDataEdit?.id !== undefined && getDataEdit?.classId !== undefined) {
      setSelectedClassId(
        GetAllCategoriesData.filter(
          (p: any) => p.id === getDataEdit?.classId
        )[0]
      );
    }
  }, [getDataEdit]);

  useEffect(() => {
    if (invitationEditData?.id !== null) {
      const newData = {
        ...invitationEditData,
        invitationId: invitationEditData?.id, // Replace with actual value
        TypeOfUpdate: 1, // Replace with actual value
      };
      setDataEdit(newData);
    } else {
      setDataEdit(null);
    }
  }, [invitationEditData]);
  //Notifications Start
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (msg: any, placement: NotificationPlacement) => {
    const key = `open${Date.now()}`;
    const btn = (
      <Space>
        <Button
          className="iran"
          type="link"
          size="small"
          onClick={() => api.destroy()}
        >
          رد کردن
        </Button>
      </Space>
    );
    api.info({
      message: "پیام",
      description: msg,
      placement,
      btn,
      key,
      className: "iran",
      onClose: close,
    });
  };
  const close = () => {
    console.log(
      "Notification was closed. Either the close button was clicked or duration time elapsed."
    );
  };

  //Notifications End
  const [invitationButtonEnabled, SetinvitationButtonEnabled] = useState(false);

  async function CreateInvitationAsync() {
    //console.log("getData", getData);

    if (getData.classId === undefined || getData.classId === "") {
      message.error("لطفا صنف فعالیت را انتخاب کنید");
      return;
    }

    if (getData.companyName === undefined || getData.companyName === "") {
      message.error("نام فروشگاه را وارد کنید");
      return;
    }

    if (getData.fullName === undefined || getData.fullName === "") {
      message.error("لطفا نام خانوادگی را وارد کنید");
      return;
    }

    if (
      (getData.phoneNumber === undefined || getData.phoneNumber === "") &&
      (getData.email === undefined || getData.email === "")
    ) {
      message.error("لطفا تلفن همراه یا ایمیل را وارد کنید");
      return;
    }

    if (checkedKeys.length === 0) {
      message.error("لطفا دسته فعالیت را انتخاب کنید");
      return;
    }

    //return;
    SetinvitationButtonEnabled(true);
    //return;
    await CreateInvitation(getData).then((p) => {
      console.log("dd", p.data);

      if (p.data.statusCode === 500) {
        SetinvitationButtonEnabled(false);
        message.error(p.data.message);
        return;
      }

      SetinvitationButtonEnabled(false);

      setData({
        InvitationType: 1,
        phoneNumber: "",
        fullName: "",
        companyName: "",
        categoryIds: [],
        email: "",
      });

      setSelectedKeys([]);
      setCheckedKeys([]);
      setExpandedKeys([]);
      onComponentChange();
    });

    // .then(() => LoadInvitations());
    //SetNewInvitationDialog(false);
  }

  //   useEffect(() => {
  //     console.log("getData", getData);
  //   }, [getData]);

  useEffect(() => {
    //console.log("checkedKeys", checkedKeys);
    setData({
      ...getData,
      ["categoryIds"]: checkedKeys,
    });
  }, [checkedKeys]);
  const { SHOW_PARENT } = TreeSelect;
  const tProps = {
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
  };
  return (
    <>
      <div style={{ width: "650px" }}>
        <h6 style={{ fontFamily: "YekanBakhVF" }} className="iran">
          ایجاد دعوت نامه{" "}
        </h6>

        <span
          style={{
            fontFamily: "YekanBakhVF",
            color: ColorPalette.gray[800],
            fontSize: "12px",
          }}
        >
          برای افراد فروشگاه مورد نظر دعوت نامه ارسال کنید
        </span>
        <hr />
        <Row className="display-flex align-items-center my-2 mt-2">
          <Col style={{ margin: "auto" }}>
            <Row style={{ height: "37px" }}>
              <Col
                style={{
                  fontFamily: "YekanBakhVF",
                  fontWeight: "314",
                  fontSize: "16px",
                  lineHeight: "28.8px",
                  color: ColorPalette.gray[950],
                }}
              >
                ورود شماره همراه یا ایمیل
              </Col>
            </Row>
            <Row>
              <Col>
                <Input
                  style={{ width: "314px", height: "40px" }}
                  onChange={(e) => {
                    SetUnSavedDataInfoManual("phoneNumber", e.target.value);
                  }}
                  value={getData["phoneNumber"]}
                  disabled={invitationEditData?.id !== undefined ? true : false}
                  className="p-2"
                />
              </Col>
            </Row>
          </Col>
          <Col style={{ margin: "auto" }}>
            <Row style={{ height: "37px" }}>
              <Col
                style={{
                  fontFamily: "YekanBakhVF",
                  fontWeight: "325",
                  fontSize: "16px",
                  lineHeight: "28.8px",
                  color: ColorPalette.gray[950],
                }}
              >
                گروه بندی فروشگاه
              </Col>
            </Row>
            <Row>
              <Col>
                <TreeSelect
                  showSearch
                  style={{ width: 314, height: "40px" }}
                  value={checkedKeys}
                  dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                  placeholder="دسته مورد نظر را انتخاب کنید"
                  //allowClear

                  {...tProps}
                  //treeDefaultExpandAll
                  onChange={async (e) => {
                    console.log("dddd", e);
                    setCheckedKeys(e);
                    //alert(e);
                    // setNoticeCategory(e);
                    // await ChangeContentAsync({
                    //   key: "categoryid",
                    //   value: e,
                    // });
                  }}
                  treeData={GetAllCategoriesData}
                  filterTreeNode={(input: any, node: any) =>
                    node.title.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="display-flex align-items-center my-2 mt-2">
          <Col style={{ margin: "auto" }}>
            <Row style={{ height: "37px" }}>
              <Col
                style={{
                  fontFamily: "YekanBakhVF",
                  fontWeight: "314",
                  fontSize: "16px",
                  lineHeight: "28.8px",
                  color: ColorPalette.gray[950],
                }}
              >
                عنوان فروشگاه{" "}
              </Col>
            </Row>
            <Row>
              <Col>
                <Input
                  style={{ width: "314px", height: "40px" }}
                  id="companyName"
                  onChange={SetUnSavedDataInfo}
                  value={
                    invitationEditData?.companyName !== undefined
                      ? invitationEditData?.companyName
                      : getData["companyName"] === undefined
                      ? ""
                      : getData["companyName"]
                  }
                  disabled={invitationEditData?.id !== undefined ? true : false}
                  className="p-2"
                />
              </Col>
            </Row>
          </Col>
          <Col style={{ margin: "auto" }}>
            <Row style={{ height: "37px" }}>
              <Col
                style={{
                  fontFamily: "YekanBakhVF",
                  fontWeight: "325",
                  fontSize: "16px",
                  lineHeight: "28.8px",
                  color: ColorPalette.gray[950],
                }}
              >
                نام رابط{" "}
              </Col>
            </Row>
            <Row>
              <Col>
                <Input
                  style={{ width: "314px", height: "40px" }}
                  id="fullName"
                  onChange={SetUnSavedDataInfo}
                  value={
                    invitationEditData?.fullName !== undefined
                      ? invitationEditData?.fullName
                      : getData["fullName"] === undefined
                      ? ""
                      : getData["fullName"]
                  }
                  disabled={invitationEditData?.id !== undefined ? true : false}
                  className="p-2"
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <TextArea
            id="description"
            rows={4}
            onChange={
              invitationEditData?.id !== undefined
                ? SetUnSavedDataInfoForEdit
                : SetUnSavedDataInfo
            }
            value={
              invitationEditData?.id !== undefined
                ? getDataEdit["description"] !== undefined
                  ? getDataEdit["description"]
                  : invitationEditData?.description
                : getData["description"] === undefined
                ? ""
                : getData["description"]
            }
            className="p-2"
            placeholder="توضیحات"
          />
        </Row>

        <Row className="display-flex align-items-center my-2 mt-2">
          <Col style={{ margin: "auto" }}>
            <Row style={{ height: "37px" }}>
              <Col
                style={{
                  fontFamily: "YekanBakhVF",
                  fontWeight: "314",
                  fontSize: "16px",
                  lineHeight: "28.8px",
                  color: ColorPalette.gray[950],
                }}
              >
                گروه بندی داخلی{" "}
              </Col>
            </Row>
            <Row>
              <Col>
                <TreeSelect
                  showSearch
                  style={{ width: 314, height: "40px" }}
                  value={getSelectedClassId}
                  dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                  placeholder="گروه بندی داخلی مدنظر را انتخاب کنید"
                  //treeDefaultExpandAll
                  onChange={async (e) => {
                    setData({
                      ...getData,
                      ["classId"]: e,
                    });
                    setSelectedClassId(e);
                  }}
                  treeData={getAllTagsData}
                  filterTreeNode={(input: any, node: any) =>
                    node.title.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Col>
            </Row>
          </Col>
          <Col style={{ margin: "auto" }}>
            <Row style={{ height: "37px" }}>
              <Col
                style={{
                  fontFamily: "YekanBakhVF",
                  fontWeight: "325",
                  fontSize: "16px",
                  lineHeight: "28.8px",
                  color: ColorPalette.gray[950],
                }}
              >
                الصاق آگهی
              </Col>
            </Row>
            <Row>
              <Col>
                <TreeSelect
                  showSearch
                  style={{ width: 314, height: "40px" }}
                  value={getSelectedNoticeOption}
                  dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                  placeholder=" آگهی مدنظر برای الصاق را انتخاب کنید"
                  //treeDefaultExpandAll
                  onChange={async (e) => {
                    setData({
                      ...getData,
                      ["noticeId"]: e,
                    });
                    setSelectedNoticeOption(e);
                  }}
                  treeData={getPublishedNoticeData}
                  filterTreeNode={(input: any, node: any) =>
                    node.title.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <hr />
        <Row
          style={{
            width: "100%",
            textAlign: "left",
            display: invitationEditData?.id !== undefined ? "none" : "block",
          }}
          className="my-2"
        >
          <Col className="p-1">
            <CustomButton
              disabled={invitationButtonEnabled}
              className="mx-1"
              LeftIconEnabled={false}
              RightIconEnabled={false}
              hasTitle={true}
              customType="Primary"
              customSize="Large"
              onClick={() => {
                //console.log("getData", getData);

                CreateInvitationAsync();
              }}
            >
              ارسال
            </CustomButton>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default NewCompanyInvitationV2;
